import pjson from '../../../package.json';
import { ENVIRONMENT } from '../config';
import { loadDash0Rum, setDash0User } from './dash0';

export { redactUrl } from './redact-url';

export interface ObservabilityUser {
  id: string;
  name?: string;
  email?: string;
}

/** Initialize browser telemetry. Call once at app entry. */
export function initObservability(): void {
  void loadDash0Rum(ENVIRONMENT, pjson.version);
}

/** Attach the logged-in buyer to the current session. */
export function setObservabilityUser(user: ObservabilityUser): void {
  void setDash0User(user);
}
